export enum Feature {
  CreditCheckSnacker = 'Credit-Check-Mitschnacker',
  Feedback = 'Feedback',
}

type FeatureToggle = {
  enabled: boolean;
  type: Feature;
  dependents?: Feature[];
};

export type FeatureToggles = {
  [key in Feature]: FeatureToggle;
};
